import React, { Component } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import PatientCard from '../../../_components/Cards/PatientCard'
import AddFormModal from '../Schedule/Component/AddFormModal';
import EventItemList from './Components/ItemList';
import EventViewActions from './Components/EventActions/EventViewActions';
import AddTelehealthModal from '../Schedule/Component/AddTelehealthModal';

import { Link } from 'react-router-dom';
import { history } from '../../../_helpers/history';
import { connect } from 'react-redux';
import { Spinner, Breadcrumb } from 'react-bootstrap';

import {
  cancelEvent,
  addEventForm,
  getEventById,
  rescheduleEvent,
  cancelEventItem,
  addEventTelehealth,
  rescheduleEventItem,
} from '../../../_actions/event.actions';
import { Can } from '../../../_contexts/AbilitiesContext';

class ViewEvent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      eventId: this.props.match.params.id,
      showAddFormModal: false,
      showAddTelehealthModal: false,
    }
  }

  componentDidMount() {
    this.props.dispatch(getEventById(this.state.eventId));
  }

  render() {
    if (this.props.loading && this.props.initLoad) {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    }

    const columns = [
      {
        sort: false,
        cell: row => {
          return <div>
            <b>Event Status:</b><br />
            <span className='badge badge-info text-uppercase'>{row.status}</span>
          </div>
        }
      },
      {
        sort: false,
        cell: row => {
          return <div>
            <b>Event Type:</b><br /> {row.type}
          </div>
        }
      },
      {
        sort: false,
        cell: row => {
          return <div>
            <b>Event Date:</b><br />
            {row.date && row.time && <>
              {moment.tz(`${row.date}T${row.time}`, row.providerGroup.timezone).local().format('l LT')}
            </>}

            {row.date && !row.time && <>
              {moment.tz(`${row.date}`, row.providerGroup.timezone).local().format('l')}
            </>}
          </div>
        }
      },
      {
        sort: false,
        cell: row => {
          return <div>
            <b>Treating Provider:</b><br /> {row.doctor.firstName} {row.doctor.lastName}
          </div>
        }
      },
      {
        sort: false,
        cell: row => {
          return <div>
            <b>Location:</b><br /> {row.providerGroup.name}
          </div>
        }
      },
      {
        button: true,
        width: '225px',
        sort: false,
        style: { justifyContent: "left" },
        cell: (row) => {
          if (row.status !== 'CANCELED') {
            return <EventViewActions event={row} rescheduling={this.props.rescheduling} cancelEvent={cancel} rescheduleEvent={reschedule} />
          }
        }
      }
    ];

    const addForm = (form) => {
      const data = {
        formId: form.form.id,
        groupId: form.providerGroup.id,
        doctorId: form.doctor.id,
        completeByDate: moment(form.date).format("Y-MM-DD HH:mm"),
        availableOnDate: moment(form.availableOn === 'Immediately' ? new Date() : form.availableOn).format("Y-MM-DD HH:mm"),
      }
      this.props.dispatch(addEventForm(this.state.eventId, data));
    }

    const addTelehealth = (telehealth) => {
      const data = {
        formId: telehealth.preVisitQuestions.id,
        groupId: telehealth.providerGroup.id,
        doctorId: telehealth.doctor.id,
        telehealthType: telehealth.telehealthType, // messaging or video
        appointmentDate: moment(telehealth.date).format("Y-MM-DD HH:mm"), // 2021-08-07 16:10
        availableOnDate: moment(telehealth.availableOn === 'Immediately' ? new Date() : telehealth.availableOn).format("Y-MM-DD HH:mm"),
      }
      this.props.dispatch(addEventTelehealth(this.state.eventId, data));
    }

    const handleSortItems = (eventItems) => {
      if (eventItems.length > 0) {
        eventItems.sort((a, b) => {
          const a_date = a.appointmentType === 'axs-links' ? a.completeByDate.date : a.appointmentDate.date;
          const b_date = b.appointmentType === 'axs-links' ? b.completeByDate.date : b.appointmentDate.date;

          return moment(a_date) - moment(b_date)
        })
      }
      return eventItems
    }

    const reschedule = (updatedEvent) => {
      const data = {
        date: moment(updatedEvent.date).format("Y-MM-DD"),
        time: updatedEvent.time ? moment(updatedEvent.time, 'H:m').format("HH:mm") : null,
        groupId: updatedEvent.group.id,
        doctorId: updatedEvent.provider.id,
      }
      this.props.dispatch(rescheduleEvent(this.state.eventId, data));
    }

    const rescheduleItem = (item, data) => {
      let type = ''
      const updated = {
        providerId: data.doctor.id,
        locationId: data.providerGroup.id,
        availableOn: data.availableOn && data.availableOn === 'Immediately' ? null : moment(data.availableOn).format("Y-MM-DD HH:mm"),
      }

      if (item.appointmentType === 'telehealth') {
        type = 'telehealth'
        updated.appointmentDate = moment(data.date).format("Y-MM-DD HH:mm");

      } else {
        type = 'form'
        updated.appointmentDate = moment(data.date).format("Y-MM-DD HH:mm");
        updated.completeByDate = moment(data.date).format("Y-MM-DD HH:mm");
      }

      this.props.dispatch(rescheduleEventItem(type, this.props.event, item, updated))
    }

    const cancel = () => {
      this.props.dispatch(cancelEvent(this.props.event.id));
    }

    const cancelItem = (item) => {
      const type = item.appointmentType === 'telehealth' ? 'telehealth' : 'form'
      this.props.dispatch(cancelEventItem(type, this.props.event, item));
    }

    return <div>
      <div className="row">
        <div className='col-md-3 col-lg-2'>
          {this.props.event &&
            this.props.event.userProfile ?
              <PatientCard
                email={this.props.event.userProfile.emailAddress}
                gender={this.props.event.userProfile.gender}
                lastName={this.props.event.userProfile.lastName}
                firstName={this.props.event.userProfile.firstName}
                profileId={this.props.event.userProfile.id}
                profileUrl={this.props.event.userProfile.profile}
                dateOfBirth={this.props.event.userProfile.dateOfBirth}
                phoneNumber={this.props.event.userProfile.phoneNumber}
              >
              <br />

              <Can I="send" a="messages">
                <Link
                  to={{
                    state: { patientId: this.props.event.userProfile.id },
                    pathname: `/messages/view`,
                  }}
                  className="w-100 btn block btn-sm btn-primary" >Message Patient</Link>
              </Can>
            </PatientCard>
            :
            <PatientCard
              profileUrl={"https://s3.amazonaws.com/axs.images/assets/profile5.png"}
              lastName={this.props.event.patientLastName}
              firstName={this.props.event.patientFirstName}
            >
              <small>
                Patient has not confirmed, <br /> no info to display.
              </small>
            </PatientCard>
          }
        </div>

        <main role="main" className="col-md-9 col-lg-10 ml-sm-auto font-weight-light">

          {this.props.alert.message &&
            <div className={`alert ${this.props.alert.type}`}>{this.props.alert.message}</div>
          }

          <Breadcrumb>
            <Breadcrumb.Item onClick={(e) => { e.preventDefault(); history.push("/events") }}>Events</Breadcrumb.Item>
            <Breadcrumb.Item active>Details</Breadcrumb.Item>
          </Breadcrumb>

          {this.props.event &&
            <DataTable
              data={[this.props.event]}
              columns={columns}
              noHeader={true}
              className="border rounded"
              noTableHead={true}
              customStyles={{ cells: { style: { fontSize: '14px', paddingTop: '1em', paddingBottom: '1em' }, }, }}
              progressPending={this.props.rescheduling}
            />
          }

          <AddFormModal
            show={this.state.showAddFormModal}
            hide={() => this.setState({ showAddFormModal: false })}
            loading={this.props.loading}
            addEventItem={addForm}
          />

          <AddTelehealthModal
            show={this.state.showAddTelehealthModal}
            hide={() => this.setState({ showAddTelehealthModal: false })}
            loading={this.props.loading}
            addEventItem={addTelehealth}
          />

          <Can I="edit" an="events">
            <div className="row d-flex flex-row-reverse mt-4 mb-2">
              {this.props.event.status === 'ACTIVE' && <>
                  <div className="col-auto">
                    <div
                      className="btn btn-primary font-weight-light"
                      onClick={() => this.setState({ showAddTelehealthModal: true })}> Schedule Telehealth
                    </div>
                  </div>
                  <div className="col-auto pr-1">
                    <div
                      className="btn btn-primary px-5 font-weight-light"
                      onClick={() => this.setState({ showAddFormModal: true })}> Send Form
                    </div>
                  </div>
              </>
              }
            </div>
          </Can>

          {this.props.items &&
            <EventItemList
              type={this.props.event.type}
              items={handleSortItems(this.props.items.data)}
              eventId={this.state.eventId}
              loading={this.props.loading}
              cancelHandler={cancelItem}
              rescheduleEventItem={rescheduleItem}
            />
          }
        </main>
      </div>
    </div>
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    event: state.event.event,
    items: state.event.items,
    loading: state.event.loading,
    initLoad: state.event.initLoad,
    rescheduling: state.event.rescheduling
  };
}

export default connect(mapStateToProps)(ViewEvent);